module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/kitchen/darksteel.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/kitchen/darksteel.jpg
// module id = 582
// module chunks = 0